import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, Renderer2 } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { GlobalVariables } from 'src/app/data/global-variables';
import { AlertService } from 'src/app/services/alert.service';
import { ConfigService } from 'src/app/services/config.service';
import { LoginService } from 'src/app/services/login.service';
import { UserAccessService } from 'src/app/services/user-access.service';

@Component({
  selector: 'app-access-locator',
  templateUrl: './access-locator.component.html',
  styleUrls: ['./access-locator.component.css']
})
export class AccessLocatorComponent {

  html_desktop: SafeHtml | undefined;
  html_mobile: SafeHtml | undefined;
  codeType: 'date' | 'text' | 'dni' | null = null;

  constructor(
    private configService: ConfigService,
    private sanitizer: DomSanitizer,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    public globalVariables: GlobalVariables,
    private alertService: AlertService,
    private loginService: LoginService,
    private userAccess: UserAccessService,
    private cookieService: CookieService,
    private http: HttpClient
  ) {
    this.http.get<string>('assets/welcomePageResources/login_desktop_locator.html', { responseType: 'string' as 'json' }).subscribe(
      next => {
        this.html_desktop = this.sanitizer.bypassSecurityTrustHtml(next);
      },
      error => {
        console.error('ERROR', error);
      });

    this.http.get<string>('assets/welcomePageResources/login_mobile_locator.html', { responseType: 'string' as 'json' }).subscribe(
      next => {
        this.html_mobile = this.sanitizer.bypassSecurityTrustHtml(next);
      },
      error => {
        console.error('ERROR', error);
      });

    this.configService.getConfig().then(c => {
      if (c.access_type?.toLowerCase() == 'date') {
        this.codeType = 'date';
      } else if (c.access_type?.toLowerCase() == 'dni') {
        this.codeType = 'dni';
      } else if (c.access_type?.toLowerCase() == 'text') {
        this.codeType = 'text';
      } else {
        this.codeType = 'text'
      }
    })

    // SCRIPTS QUE SON LLAMADOS DESDE EL HTML
    let script = this._renderer2.createElement('script');
    script.type = `text/javascript`;
    script.text = `
          function sendLogin() {
            let locator = document.getElementById('locator').value;
            let code = document.getElementById('code').value;
            let disclaimer = document.getElementById('disclaimer');
            if(disclaimer==null) {
              const event = new CustomEvent("login", { detail: {code,locator} });
              document.dispatchEvent(event);
            } else {
              if(disclaimer.checked) {
                const event = new CustomEvent("login", { detail: {code,locator} });
                document.dispatchEvent(event);
              } else {
                if(
                  document.getElementById('locator').value==null || document.getElementById('locator').value.trim()=='' ||
                  document.getElementById('code').value==null || document.getElementById('code').value.trim()==''
                ) {
                  alert('Introduzca todos los datos solicitados para acceder a sus resultados');
                } else {
                  alert('Debe aceptar los términos y condiciones para continuar');
                }
              }
            }
          }
        `;

      this._renderer2.appendChild(this._document.body, script);

      document.addEventListener("login", (evt: Event) => {
        const { code, locator } = (evt as CustomEvent).detail;
        console.log('code', code);
        console.log('locator', locator);
        this.checkAccess(locator, code);
      })
  }

  private checkAccess(locator: string, code: string) {
    if (code == null || code.trim() == '') {
      this.alertService.alert("Por favor, introduzca el código de acceso");
      return;
    }
    if (this.codeType == 'date') {
      const parsed = this.loginService.parseDate(code);
      if (parsed == null) return;
      code = parsed
    }
    if (this.codeType == 'dni') {
      if (code.length < 9) {
        this.alertService.alert("El DNI debe tener 9 caracteres");
        return;
      }
      const dniRegex = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKETtrwagmyfpdxbnjzsqvhlcket]|[XYZxyz][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKETtrwagmyfpdxbnjzsqvhlcket]$/;
      if (!dniRegex.test(code)) {
        this.alertService.alert("El DNI no es válido. Se debe escribir sin puntos ni guiones, por ejemplo 12345678A o X1234567A");
        return;
      }
    }
    console.log('code', code);
    this.userAccess.grantAccessWithLocator(locator, code)
      .then(res => {

        this.cookieService.set('code', code);
        const url = `book-pdf?tkn=${res}`;
        window.location.href = url;
      })
      .catch(err => {
        this.loginService.showError(err)
      })
  }

}
